export enum TipoNotificacao {
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
  Information = 'information',
}

export enum TipoIcone {
    Check = 'check',
    Error = 'error_circle_base',
    Info = 'informacao_outline'
}